import { Component, OnInit, ViewChild } from '@angular/core';
import { MetaService } from 'services/meta.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Location, LocationService } from 'services/location.service';
import { ValidationService } from 'services/validation.service';

@Component({
	selector: 'ras-contact-page',
	templateUrl: './contact-page.component.html',
	styleUrls: ['./contact-page.component.sass']
})
export class ContactPageComponent implements OnInit {

	public location = null
	public name
	public surname
	public cell
	public email
	public message = ""

	public locations: Location[]
	public busy = false
	public form_sent = false
	public form_error = false
	public show_invalid = false

	constructor(private http: HttpClient, private locationService: LocationService, public valid: ValidationService, private metaService: MetaService) { }

	ngOnInit() {
		this.metaService.apply('contact')

		this.locationService.get_all()
		.then(locations => {
			// Add display_name with area in brackets for locations with duplicate names
			const nameCounts = locations.reduce((acc, loc) => {
				acc[loc.name] = (acc[loc.name] || 0) + 1;
				return acc;
			}, {} as Record<string, number>);

			this.locations = locations.map(loc => ({
				...loc,
				display_name: nameCounts[loc.name] > 1 ? `${loc.name} (${loc.area})` : loc.name
			}));
		})
	}

	send_message() {
		console.log('Send message called');
		console.log('Form data:', {
			location: this.location,
			name: this.name,
			surname: this.surname,
			cell: this.cell,
			email: this.email,
			message: this.message
		});

		// Enhanced validation with logging
		if (!this.location || !this.location.name) {
			console.error('Location not selected or location name missing');
			this.show_invalid = true;
			return;
		}

		if (!this.valid.sa_cell_number(this.cell)) {
			console.error('Invalid cell number:', this.cell);
			this.show_invalid = true;
			return;
		}

		if (!this.valid.email(this.email)) {
			console.error('Invalid email:', this.email);
			this.show_invalid = true;
			return;
		}

		this.busy = true;
		this.form_error = false;
		this.show_invalid = false;

		// Google Analytics tracking
		if ((<any>window).dataLayer) {
			(<any>window).dataLayer.push({
				'event': 'formSubmission',
				'formType': 'Contact us',
				'formId': 'contact-form'
			});
		}

		// Prepare request data
		const requestData = {
			branch: this.location.name,
			first_name: this.name,
			last_name: this.surname,
			cell: this.cell,
			email: this.email,
			message: this.message || "Please call me"
		};

		console.log('Request data being sent:', requestData);

		// Set up headers
		const headers = new HttpHeaders({
			'Content-Type': 'application/json',
			'Accept': 'application/json, text/plain, */*'
		});

		console.log('Request headers:', headers);

		try {
			this.http.post(
				'https://portal.rentastore.co.za/api/server/contact',
				requestData,
				{
					headers: headers,
					responseType: 'text',
					observe: 'response'
				}
			)
			.toPromise()
			.then(response => {
				console.log('Success response:', response);
				console.log('Response status:', response.status);
				console.log('Response body:', response.body);
				
				this.busy = false;
				this.form_sent = true;
				this.form_error = false;
				
				// Clear form
				this.name = '';
				this.surname = '';
				this.cell = '';
				this.email = '';
				this.message = '';
				this.location = null;
				
				console.log('Form submitted successfully');
			})
			.catch(error => {
				console.error('HTTP Error:', error);
				this.handleError(error);
			});

		} catch (exception) {
			console.error('Exception in send_message:', exception);
			this.form_error = true;
			this.busy = false;
		}
	}

	private handleError(error: any) {
		this.busy = false;
		this.form_error = true;

		if (error instanceof HttpErrorResponse) {
			console.error('HTTP Error Response:', {
				status: error.status,
				statusText: error.statusText,
				message: error.message,
				error: error.error,
				url: error.url
			});

			// Handle specific error cases
			switch (error.status) {
				case 0:
					console.error('Network error - possibly CORS issue or server unreachable');
					break;
				case 400:
					console.error('Bad Request - check request format');
					break;
				case 401:
					console.error('Unauthorized - authentication required');
					break;
				case 403:
					console.error('Forbidden - access denied');
					break;
				case 404:
					console.error('Not Found - endpoint does not exist');
					break;
				case 500:
					console.error('Internal Server Error');
					break;
				default:
					console.error('Unknown HTTP error');
			}
		} else {
			console.error('Non-HTTP Error:', error);
		}
	}

	// Alternative method using Observable instead of Promise
	send_message_observable() {
		console.log('Send message (Observable version) called');

		if (!this.location || !this.location.name || !this.valid.sa_cell_number(this.cell) || !this.valid.email(this.email)) {
			this.show_invalid = true;
			return;
		}

		this.busy = true;
		this.form_error = false;
		this.show_invalid = false;

		const requestData = {
			branch: this.location.name,
			first_name: this.name,
			last_name: this.surname,
			cell: this.cell,
			email: this.email,
			message: this.message || "Please call me"
		};

		const headers = new HttpHeaders({
			'Content-Type': 'application/json',
			'Accept': 'application/json, text/plain, */*'
		});

		this.http.post(
			'https://portal.rentastore.co.za/api/server/contact',
			requestData,
			{
				headers: headers,
				responseType: 'text'
			}
		).subscribe({
			next: (response) => {
				console.log('Success response:', response);
				this.busy = false;
				this.form_sent = true;
				this.form_error = false;
				
				// Clear form
				this.name = '';
				this.surname = '';
				this.cell = '';
				this.email = '';
				this.message = '';
				this.location = null;
			},
			error: (error) => {
				console.error('Error:', error);
				this.handleError(error);
			}
		});
	}

	// Method to test CORS
	test_cors() {
		console.log('Testing CORS...');
		
		this.http.get('https://portal.rentastore.co.za/api/server/contact', {
			responseType: 'text'
		}).subscribe({
			next: (response) => {
				console.log('CORS test successful:', response);
			},
			error: (error) => {
				console.error('CORS test failed:', error);
			}
		});
	}
}